var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDash2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9916 19.634C30.9845 19.1382 31.0269 18.6425 31.133 18.1601C31.2107 17.8117 31.0694 17.4499 30.7795 17.2288L29.3093 16.11C28.9912 15.8688 28.9064 15.4401 29.1114 15.1051L29.5496 14.3949C29.7546 14.0599 30.1858 13.9126 30.5675 14.0599L32.3346 14.7098C32.681 14.8371 33.0839 14.7701 33.3595 14.5356C34.0664 13.9394 34.8934 13.4838 35.7911 13.1957C36.1445 13.0818 36.4061 12.7937 36.4626 12.4386L36.7524 10.6633C36.809 10.2814 37.1624 10 37.5724 10H38.4418C38.8518 10 39.1981 10.2814 39.2617 10.6633L39.5515 12.4319C39.6081 12.787 39.8696 13.0751 40.223 13.189C41.1207 13.4704 41.9477 13.926 42.6546 14.5289C42.9373 14.7634 43.3332 14.8304 43.6795 14.7031L45.4466 14.0532C45.8213 13.9193 46.2454 14.0599 46.4504 14.3882L46.8886 15.0984C47.0936 15.4334 47.0088 15.8621 46.6907 16.1033L45.2205 17.2221C44.9306 17.4432 44.7893 17.805 44.867 18.1534C45.0579 19.0377 45.0579 19.9489 44.867 20.8332C44.7893 21.1816 44.9306 21.5434 45.2205 21.7645L46.6907 22.8833C47.0088 23.1245 47.0936 23.5532 46.8886 23.8882L46.4504 24.5984C46.2525 24.9267 45.8283 25.074 45.4466 24.9401L43.6795 24.2902C43.3332 24.1629 42.9303 24.2299 42.6546 24.4644C41.9477 25.0606 41.1207 25.5162 40.223 25.8043C39.8696 25.9182 39.6081 26.2063 39.5515 26.5614L39.2617 28.3367C39.2052 28.7186 38.8518 29 38.4418 29H37.5724",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24C40.2081 24 42 22.2081 42 20C42 17.7919 40.2081 16 38 16C35.7919 16 34 17.7919 34 20",
    stroke: "url(#paint0_linear)",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9966 31H48.4034C49.8346 31 51 32.1544 51 33.557V47.5034C51 48.9128 49.8278 50.0604 48.4034 50.0604H47.8377L47.9672 55L40.2729 50.0671H27.5966C26.1654 50.0671 25 48.9127 25 47.5101V39.5101",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9966 31H48.4034C49.8346 31 51 32.1544 51 33.557V47.5034C51 48.9128 49.8278 50.0604 48.4034 50.0604H47.8377L47.9672 55L40.2729 50.0671H27.5966C26.1654 50.0671 25 48.9127 25 47.5101V39.5101",
    stroke: "#9A9FB0",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6933 39.0618H16.0406L15.9161 44L23.3145 39.0618H35.3067C36.7877 39.0618 38 37.8205 38 36.3042V22.7576C38 21.2413 36.7877 20 35.3067 20H15.6933C14.2123 19.9933 13 21.2413 13 22.7576V36.2975C13 37.8205 14.2123 39.0618 15.6933 39.0618Z",
    fill: "white",
    stroke: "#9A9FB0",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.011 31H18.989C18.4451 31 18 30.5549 18 30.011V28.989C18 28.4451 18.4451 28 18.989 28H20.011C20.5549 28 21 28.4451 21 28.989V30.011C21 30.5549 20.5549 31 20.011 31Z",
    stroke: "url(#paint1_linear)",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.011 31H24.989C24.4451 31 24 30.5549 24 30.011V28.989C24 28.4451 24.4451 28 24.989 28H26.011C26.5549 28 27 28.4451 27 28.989V30.011C27 30.5549 26.5549 31 26.011 31Z",
    stroke: "url(#paint2_linear)",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.011 31H30.989C30.4451 31 30 30.5549 30 30.011V28.989C30 28.4451 30.4451 28 30.989 28H32.011C32.5549 28 33 28.4451 33 28.989V30.011C33 30.5549 32.5549 31 32.011 31Z",
    stroke: "url(#paint3_linear)",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 34.7059,
    y1: 20.8539,
    x2: 42.0929,
    y2: 18.2402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 18.2647,
    y1: 29.8202,
    x2: 21.0349,
    y2: 28.8401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 24.2647,
    y1: 29.8202,
    x2: 27.0349,
    y2: 28.8401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 30.2647,
    y1: 29.8202,
    x2: 33.0349,
    y2: 28.8401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash2);
export default __webpack_public_path__ + "static/media/dash2.ee36d26b8a5c18b3939c404a06710cdf.svg";
export { ForwardRef as ReactComponent };